import Wish from './ui/main/Wish';
import Modal from './ui/Modal/Modal';
import { FOR_ID, FOR_NAME } from './constants/modalTypes';
import badWords from './constants/badWords';

export default Wish;

export { Modal, FOR_ID, FOR_NAME, badWords };
